<template>
  <transition name="el-fade-in-linear">
    <div v-show="show" class="home">
      <el-container>
        <div class="home_banner1">
          <el-image
            :src="require('@/assets/zu7_2x.png')"
            fit="fill">
          </el-image>
          <p class="title middle">{{$t('el.d.home_m1_c1')}}</p>
          <p class="content middle">{{$t('el.d.home_m1_c2')}}</p>
          <el-button class="middle" type="primary" @click="mpShow = true">{{$t('el.d.home_m1_c3')}}
          </el-button>
        </div>
      </el-container>
      <el-container class="home_down_btn middle">
        <el-main>
          <el-image
            src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/btn_down.png"
            fit="fill">
          </el-image>
        </el-main>
      </el-container>
      <el-container class="middle">
        <div class="home_bus">
          <el-image
            :src="require('@/assets/icon_zhang.png')"
            fit="contain">
          </el-image>
          <br>
          <p class="title">{{$t('el.d.home_m2_c1')}}</p>
          <p class="content">{{$t('el.d.home_m2_c4')}}</p>
        </div>
        <div class="home_bus">
          <el-image
            :src="require('@/assets/icon_pos.png')"
            fit="fill">
          </el-image>
          <br>
          <p class="title">{{$t('el.d.home_m2_c2')}}</p>
          <p class="content">{{$t('el.d.home_m2_c5')}}</p>
        </div>
        <div class="home_bus">
          <el-image
            :src="require('@/assets/icon_tel.png')"
            fit="fill">
          </el-image>
          <br>
          <p class="title">{{$t('el.d.home_m2_c3')}}</p>
          <p class="content">{{$t('el.d.home_m2_c6')}}</p>
        </div>
      </el-container>
      <el-container>
        <div>
          <el-image
            :src="require('@/assets/shiwu_2x.png')"
            fit="fill">
          </el-image>
          <div class="left_content middle">
            <div class="title">
              <img src="../assets/xswcsw_2x.png"/>
              <p>{{$t('el.d.home_m3_c1')}}</p>
            </div>
            <p class="xswcswContent">{{$t('el.d.home_m3_c2')}}</p>
          </div>
        </div>
      </el-container>
      <el-container class="recover1">
        <div>
          <el-image
            :src="require('@/assets/wangxian_2x.png')"
            fit="fill">
          </el-image>
          <div class="right_content middle">
            <div class="title"><img src="../assets/znsswd_2x.png"/><p>{{$t('el.d.home_m4_c1')}}</p></div>
            <p class="content">{{$t('el.d.home_m4_c2')}}</p>
          </div>
        </div>
      </el-container>
      <el-container class="recover2">
        <div>
          <el-image
            :src="require('@/assets/sspzz_2x.png')"
            fit="fill">
          </el-image>
          <div class="left_content middle">
            <div class="title"><img src="../assets/xj_2x.png" height="25" width="25"/><p>{{$t('el.d.home_m5_c1')}}</p></div>
            <p class="content">{{$t('el.d.home_m5_c2')}}</p>
          </div>
        </div>
      </el-container>
      <el-container class="recover3">
        <div>
          <el-image
            :src="require('@/assets/dup_2x.png')"
            fit="fill">
          </el-image>
          <div class="left_content middle">
            <p class="title">{{$t('el.d.home_m6_c1')}}</p>
            <el-image src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_iphone.png" fit="fit"
            ></el-image>
            <el-image src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_android.png" fit="fit"
            ></el-image>
            <el-image src="http://lan-zheng.oss-cn-shanghai.aliyuncs.com/img/icon_win.png" fit="fit"
            ></el-image>
          </div>
        </div>
      </el-container>
      <el-dialog :visible.sync="mpShow" width="250px" top="30vh">
        <el-image
          :src="require('@/assets/mp_2x.png')"
          fit="fill">
        </el-image>
      </el-dialog>
      <el-container class="recover4">
        <Footer id="footer"/>
      </el-container>
    </div>
  </transition>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'home',
  components: {Header, Footer},
  inject: ['open'],
  data () {
    return {
      show: false,
      mpShow: false
    }
  },
  methods: {
    showMp () {
      // Header.methods.showMp()
      this.open()
    }
  },
  mounted () {
    this.show = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/Home.vue